import { jsPDF } from 'jspdf'
import JsBarcode from 'jsbarcode'

export const LABEL_SIZE_MM = { width: 76, height: 102 }

const MARGIN_TOP_RATIO = 0.1
const BARCODE_WIDTH_RATIO = 0.92
const TEXT_GAP_RATIO = 0.08
const FONT_SIZE_RATIO = 0.28
const MIN_FONT_SIZE_RATIO = 0.08
const TEXT_MAX_WIDTH_RATIO = 0.92

export const UNPRINTABLE_BARCODE_MESSAGE = 'Barcode has characters a label cannot encode'

// JsBarcode's CODE128 turns \xC8-\xD3 into function codes and throws on other non-ASCII;
// control characters would encode, but a scanner sends them back as keystrokes.
const PRINTABLE_ASCII = /^[\x20-\x7E]+$/

// Only the barcode is drawn (CUBBO-3011): nothing else from the job reaches the label.
export const buildLabelPdf = (job, size = LABEL_SIZE_MM) => {
  const barcode = job?.barcode
  if (!barcode) throw new Error('Cannot build a label without a barcode')
  if (!PRINTABLE_ASCII.test(barcode)) throw new Error(UNPRINTABLE_BARCODE_MESSAGE)

  // jsPDF swaps a format whose orientation disagrees with its sides.
  const orientation = size.width > size.height ? 'landscape' : 'portrait'
  const pdf = new jsPDF({ orientation, unit: 'mm', format: [size.width, size.height] })
  const pageWidth = pdf.internal.pageSize.getWidth()

  const canvas = document.createElement('canvas')
  JsBarcode(canvas, barcode, { format: 'CODE128', displayValue: false })
  const image = canvas.toDataURL('image/png')
  const imageProps = pdf.getImageProperties(image)

  const top = size.height * MARGIN_TOP_RATIO
  const imageWidth = size.width * BARCODE_WIDTH_RATIO
  const imageHeight = (imageProps.height * imageWidth) / imageProps.width
  pdf.addImage(image, 'PNG', (pageWidth - imageWidth) / 2, top, imageWidth, imageHeight)

  const maxFontSize = size.width * FONT_SIZE_RATIO
  pdf.setFontSize(maxFontSize)
  pdf.setFont('helvetica', 'bold')
  const textWidth = pdf.getTextWidth(barcode)
  const maxTextWidth = size.width * TEXT_MAX_WIDTH_RATIO
  if (textWidth > maxTextWidth) pdf.setFontSize(Math.max(size.width * MIN_FONT_SIZE_RATIO, (maxFontSize * maxTextWidth) / textWidth))
  pdf.text(barcode, pageWidth / 2, top + imageHeight + size.height * TEXT_GAP_RATIO, { align: 'center' })

  return pdf.output('blob')
}
